const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Mobile/MobileProject');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class MobileProject extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="226"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="30,31,30,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<ImageView
						id={this.id("Group_5")}
						height="33"
						width="match_parent"
						margin="10,0,10,0"
						imageUrl="group570"
						style={this.style_Group_5} />
					<TextView
						id={this.id("Register")}
						height="25"
						width="match_parent"
						margin="0,44,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Register} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Group")}
					height="1954"
					width="match_parent"
					orientation="vertical"
					margin="29,20,29,0"
					cornerRadius="0"
					style={this.style_Group}>
					<TextView
						id={this.id("Internship___Juspay")}
						height="80"
						width="match_parent"
						margin="2,0,0,0"
						text={this.STR.Internship___Juspay29}
						textSize={FontSize.A_32}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="40px"
						gravity="left"
						style={this.style_Internship___Juspay} />
					<TextView
						id={this.id("While_learning_to_cr")}
						height="270"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.While_learning_to_cr87}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_While_learning_to_cr} />
					<TextView
						id={this.id("Project")}
						height="33"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.Project31}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						gravity="left"
						style={this.style_Project} />
					<TextView
						id={this.id("Overview")}
						height="25"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.Overview32}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Overview} />
					<TextView
						id={this.id("For_an_eager_learner")}
						height="150"
						width="match_parent"
						margin="2,10,0,0"
						text={this.STR.For_an_eager_learner33}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_For_an_eager_learner} />
					<TextView
						id={this.id("The_app_will_allow_l")}
						height="180"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.The_app_will_allow_l34}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_The_app_will_allow_l} />
					<TextView
						id={this.id("App_Features")}
						height="30"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.App_Features35}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="28px"
						gravity="left"
						style={this.style_App_Features} />
					<TextView
						id={this.id("Register100000000ø")}
						height="30"
						width="match_parent"
						margin="2,10,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="28px"
						gravity="left"
						style={this.style_Register100000000ø} />
					<LinearLayout
						id={this.id("Ug2")}
						height="60"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_Ug2}>
						<LinearLayout
							id={this.id("Bullet")}
							height="8"
							width="8"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet}>
							<ImageView
								id={this.id("Group200000000ø")}
								height="8"
								width="8"
								imageUrl="group72"
								style={this.style_Group200000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("Get_user_details_lik")}
							height="60"
							width="282"
							margin="10,0,0,0"
							weight="1"
							text={this.STR.Get_user_details_lik36}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Get_user_details_lik} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Ug1")}
						height="120"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_Ug1}>
						<LinearLayout
							id={this.id("Bullet300000000ø")}
							height="8"
							width="8"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet300000000ø}>
							<ImageView
								id={this.id("Group400000000ø")}
								height="8"
								width="8"
								imageUrl="group73"
								style={this.style_Group400000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("If_user_is_a_learner")}
							height="120"
							width="282"
							margin="10,0,0,0"
							weight="1"
							text={this.STR.If_user_is_a_learner37}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_If_user_is_a_learner} />
					</LinearLayout>
					<TextView
						id={this.id("Explore")}
						height="25"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.Explore38}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						gravity="left"
						style={this.style_Explore} />
					<TextView
						id={this.id("A_learner_can_explor")}
						height="120"
						width="match_parent"
						margin="2,5,0,0"
						text={this.STR.A_learner_can_explor39}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_A_learner_can_explor} />
					<TextView
						id={this.id("Learn")}
						height="25"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Learn40}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						gravity="left"
						style={this.style_Learn} />
					<TextView
						id={this.id("A_learner_can_commun")}
						height="90"
						width="match_parent"
						margin="2,9,0,0"
						text={this.STR.A_learner_can_commun41}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_A_learner_can_commun} />
					<TextView
						id={this.id("Tips")}
						height="30"
						width="match_parent"
						margin="2,20,0,0"
						text={this.STR.Tips42}
						textSize={FontSize.A_18}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_HEAVY}
						lineHeight="28px"
						gravity="left"
						style={this.style_Tips} />
					<LinearLayout
						id={this.id("G4")}
						height="60"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_G4}>
						<LinearLayout
							id={this.id("Bullet500000000ø")}
							height="8"
							width="8"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet500000000ø}>
							<ImageView
								id={this.id("Group600000000ø")}
								height="8"
								width="8"
								imageUrl="group74"
								style={this.style_Group600000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("Use_a_hosted_server")}
							height="60"
							width="282"
							margin="10,0,0,0"
							weight="1"
							text={this.STR.Use_a_hosted_server43}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Use_a_hosted_server} />
					</LinearLayout>
					<LinearLayout
						id={this.id("G1")}
						height="60"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_G1}>
						<LinearLayout
							id={this.id("Bullet700000000ø")}
							height="8"
							width="7"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet700000000ø}>
							<ImageView
								id={this.id("Group800000000ø")}
								height="8"
								width="7"
								imageUrl="group77"
								style={this.style_Group800000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("If_that_is_not_possi")}
							height="60"
							width="283"
							margin="9,0,0,0"
							weight="1"
							text={this.STR.If_that_is_not_possi44}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_If_that_is_not_possi} />
					</LinearLayout>
					<LinearLayout
						id={this.id("G3")}
						height="60"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_G3}>
						<LinearLayout
							id={this.id("Bullet900000000ø")}
							height="8"
							width="8"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet900000000ø}>
							<ImageView
								id={this.id("Group1000000000ø")}
								height="8"
								width="8"
								imageUrl="group75"
								style={this.style_Group1000000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("Use_websockets_for_i")}
							height="60"
							width="282"
							margin="10,0,0,0"
							weight="1"
							text={this.STR.Use_websockets_for_i45}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Use_websockets_for_i} />
					</LinearLayout>
					<LinearLayout
						id={this.id("G2")}
						height="120"
						width="match_parent"
						orientation="horizontal"
						margin="2,10,0,0"
						style={this.style_G2}>
						<LinearLayout
							id={this.id("Bullet1100000000ø")}
							height="8"
							width="8"
							orientation="horizontal"
							gravity="center"
							margin="0,11,0,0"
							style={this.style_Bullet1100000000ø}>
							<ImageView
								id={this.id("Group1200000000ø")}
								height="8"
								width="8"
								imageUrl="group76"
								style={this.style_Group1200000000ø} />
						</LinearLayout>
						<TextView
							id={this.id("Feel_free_to_design")}
							height="120"
							width="282"
							margin="10,0,0,0"
							weight="1"
							text={this.STR.Feel_free_to_design46}
							textSize={FontSize.A_18}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Feel_free_to_design} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Group_3")}
						height="60"
						width="200"
						orientation="vertical"
						padding="60,14,0,13"
						margin="2,30,0,0"
						background={Color.A__FFFF0000}
						cornerRadius="4"
						style={this.style_Group_3}>
						<TextView
							id={this.id("Submit")}
							height="33"
							width="80"
							text={this.STR.Submit47}
							textSize={FontSize.A_24}
							color={FontColor.A__FFFFFFFF}
							fontStyle={Font.AVENIR_BLACK}
							gravity="left"
							style={this.style_Submit} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Rectangle")}
						height="37"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						margin="2,5,0,0"
						cornerRadius="0"
						style={this.style_Rectangle} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = MobileProject;



// WEBPACK FOOTER //
// ./views/Mobile/MobileProject.js